export default __webpack_public_path__ + "static/char-thumb-08-d85cad85f3a82611186fb48e06abb461.png";